
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"423.234","height":"534.691","viewBox":"0 0 423.234 534.691"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 29864","d":"M276.532 526.96a15 15 0 01-21.75-18.196c20.48-53.721 59.654-192.756-18.782-323.296-40.683-69.035-125.317-100.895-201.304-75.867a15 15 0 11-9.385-28.494c89.29-29.41 188.74 8.028 236.471 89.024 85.153 141.718 43.078 291.508 21.032 349.325a14.937 14.937 0 01-6.282 7.505z","fill":"#fff"}})])
          )
        }
      }
    